
















































































































































































































import Vue from "vue";

// Model
import { formatCurrency } from "@/utility/Formatter.js";
import { ChannelsBalanceReportEntry } from "@/model/data/channelsBalance/ChannelsBalanceReportEntry";

export default Vue.extend({
    data() {
        return {
            search: "",
            headers: [
                { text: this.$t("usersBalance.cashIn"), value: "cashIn", sortable: false, align: "end" },
                { text: this.$t("usersBalance.cashOut"), value: "cashOut", sortable: false, align: "end" },
                { text: this.$t("usersBalance.cashBalance"), value: "cashBalance", sortable: false, align: "end" },
                { text: this.$t("usersBalance.manualDeposit"), value: "manualDeposit", sortable: false, align: "end" },
                { text: this.$t("usersBalance.balance"), value: "balance", sortable: false, align: "end" },
            ],
            expandAll: true,
        };
    },
    props: {
        loading: { type: Boolean, default: false },
        channelsBalanceReportEntries: { type: Array as () => ChannelsBalanceReportEntry[] },
        isTotalsTable: { type: Boolean, default: false },
        analizedTransactionsCount: { type: Number },
    },
    computed: {
        computedHeaders() {
            let res = [];
            if (!this.isTotalsTable) {
                res.push({ text: this.$t("channelsBalance.channel"), value: "channel", sortable: false });
            }
            this.headers.forEach((h) => {
                res.push(h);
            });
            if (!this.isTotalsTable) {
                res.push({ text: this.$t("usersBalance.kitWithdrawn"), value: "kitWithdrawn", sortable: false, align: "end" });
                res.push({ text: this.$t("usersBalance.endShiftDeposited"), value: "endShiftDeposited", sortable: false, align: "end" });
            }
            return res;
        },
        analizedTransactionsCountComputed() {
            return new Intl.NumberFormat(navigator.language).format(this.analizedTransactionsCount);
        },
    },
    methods: {
        formatCurrency,
        getRowClasses(item) {
            return {
                "level-0": item.channelHierarchyLevel == 0,
                "level-1": item.channelHierarchyLevel === 1,
                "level-2": item.channelHierarchyLevel === 2,
                "level-3": item.channelHierarchyLevel === 3,
                "level-4": item.channelHierarchyLevel === 4,
                "level-5": item.channelHierarchyLevel === 5,
                "level-6": item.channelHierarchyLevel === 6,
            };
        },
    },
});
